export const messages = {
  en: {
    newOaWorkflowFormEdit: {
      title: 'Edit',
      submit: 'Submit',
      cancel: 'Cancel',
      requiredMessage: ' is required',
      submitSuccess: 'Submit successfully',
      submitError: 'Submit failed'
    },
    uploadFile: {
      uploadBtn: 'Upload Attachment',
      sizeLimit: 'File size cannot exceed 20MB',
      uploadSuccess: 'File uploaded successfully',
      uploadError: 'File upload failed'
    }
  },
  zh: {
    newOaWorkflowFormEdit: {
      title: '编辑',
      submit: '提交',
      cancel: '取消',
      requiredMessage: '不能为空',
      submitSuccess: '提交成功',
      submitError: '提交失败'
    },
    uploadFile: {
      uploadBtn: '上传附件',
      sizeLimit: '文件大小不能超过20MB',
      uploadSuccess: '文件上传成功',
uploadError: '文件上传失败'
    }
  },
  'zh-TW': {
    newOaWorkflowFormEdit: {
      title: '編輯',
      submit: '提交',
      cancel: '取消',
      requiredMessage: '不能為空',
      submitSuccess: '提交成功',
      submitError: '提交失敗'
    },
    uploadFile: {
      uploadBtn: '上傳附件',
      sizeLimit: '文件大小不能超過20MB',
      uploadSuccess: '文件上傳成功',
      uploadError: '文件上傳失敗'
    }
  }
}